import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "sonner";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Gallery from "@/pages/Gallery";
import PetDetail from "@/pages/PetDetail";
import Favorites from "@/pages/Favorites";
import Albums from "@/pages/Albums";
import ShareView from "@/pages/ShareView";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

const TOAST_OPTIONS = {
  style: {
    background: "#FFF",
    border: "1px solid #EAE2D6",
    color: "#2D232E",
    fontFamily: "Nunito, sans-serif",
  },
};

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]">
        <div className="font-hand text-3xl text-[#E76F51] gentle-float">Fetching your pack...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App paper-grain">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="bottom-right" richColors toastOptions={TOAST_OPTIONS} />
          <Routes>
            <Route path="/share/:token" element={<ShareView />} />
            <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
            <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
            <Route path="/pricing" element={<ProtectedRoute><Pricing /></ProtectedRoute>} />
            <Route path="/auth" element={<PublicOnly><Auth /></PublicOnly>} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/gallery" element={<ProtectedRoute><Gallery /></ProtectedRoute>} />
            <Route path="/favorites" element={<ProtectedRoute><Favorites /></ProtectedRoute>} />
            <Route path="/albums" element={<ProtectedRoute><Albums /></ProtectedRoute>} />
            <Route path="/pets/:petId" element={<ProtectedRoute><PetDetail /></ProtectedRoute>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
